var caseBanner;

caseBanner = function() {
  var $, module, moduleImage, moduleName, resizeBg;
  $ = require('jquery');
  moduleName = 'page_banner';
  module = $("." + moduleName);
  moduleImage = module.find('img');
  resizeBg = require('../../../_scripts/functions/resizebg');
  return resizeBg(moduleImage);
};

module.exports = caseBanner;
